import React from "react"
import ReactCountryFlag from "react-country-flag"
import CountryNameToCodeMapper from "./CountryNameToCodeMapper";

const CountryFlag = ({countryName, height = '25px', width = '25px', isCircle = false}) => {
    const countryCode = CountryNameToCodeMapper(countryName)
    return (
        <div>
            <ReactCountryFlag
                style={{height: height, width: width, borderRadius: isCircle ? '50%' : '0px', opacity: '90%'}}
                countryCode={countryCode} isCircle={isCircle}
                alt={countryName} svg/>
        </div>
    )
}

export default CountryFlag

/*

 <ReactCountryFlag
                countryCode="US"
                svg
                style={{
                    width: '2em',
                    height: '2em',
                }}
                title="US"
            />

            <ReactCountryFlag
                countryCode="US"
                svg
                cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
                cdnSuffix="svg"
                title="US"
            />
 */